"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // We need to centralize the zIndex definitions as they work
// like global values in the browser.

var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
exports.default = _default;